
          import "Tab.styles_ioy2kk.linaria.css";
          import { typeStyle } from "@carvana/showroom-css-theme";
import { styled } from "@linaria/react";
const TabContainer = /*#__PURE__*/styled("div")({
  name: "TabContainer",
  class: "t61shjq"
});
export default TabContainer;
          